import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { GridTargetsBase } from '../grid-target-base';
import { getUserSetDatesBasicConfig } from './basic-config';
import { areEqual } from '../components/utility';

export const UserSetDatesTargetSetting = React.memo((props) => {
  const i18n = useContext(I18nContext);
  const {
    data, setData, patchErrMsg, patchTargetsApiErrMsg, apiErrors,
  } = props;

  const params = {
    ...getUserSetDatesBasicConfig(i18n),
    validateParams: { targetId: 'user-set-dates-target-wrapper', patchErrMsg, targetName: 'userSetDates' },
    patchTargetsApiErrMsg,
    apiErrors,
  };

  return (
    <div id="user-set-dates-target-wrapper">
      <GridTargetsBase data={data} setData={setData} {...params} />
    </div>
  );
}, areEqual);

UserSetDatesTargetSetting.propTypes = {
  data: PropTypes.shape({}).isRequired,
  setData: PropTypes.func.isRequired,
  patchErrMsg: PropTypes.func,
  patchTargetsApiErrMsg: PropTypes.func,
  apiErrors: PropTypes.arrayOf(PropTypes.string),
};
UserSetDatesTargetSetting.defaultProps = {
  patchErrMsg() {},
  patchTargetsApiErrMsg() {},
  apiErrors: [],
};
